export const getTalkIdsFromTags = (tags) => {
    if(!tags || tags.length === 0) {
        return []
    }
    return tags.map(tag => tag.talks).reduce((arr, talks) => [...arr, ...talks])
};



// WEBPACK FOOTER //
// ./src/components/tags/TagHelper.js